import type { DragEvent, FC } from 'react';
import { Box } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import type { CreativeDnDZone } from '../../types/hypothesis';
import {
  attachCreativeDragPreview,
  HYPOTHESIS_CREATIVE_DRAG_MIME,
  serializeHypothesisCreativeDrag,
  type HypothesisCreativeDragData,
} from './hypothesisCreativeDnD';

interface CreativeDragHandleProps {
  creativeId: string;
  rowIndex: number;
  zone: CreativeDnDZone;
  onDragStart?: (creativeId: string) => void;
  onDragEnd?: () => void;
}

const CreativeDragHandle: FC<CreativeDragHandleProps> = ({
  creativeId,
  rowIndex,
  zone,
  onDragStart,
  onDragEnd,
}) => {
  const handleDragStart = (event: DragEvent<HTMLDivElement>) => {
    const payload: HypothesisCreativeDragData = {
      creativeId,
      from:
        zone.kind === 'pack'
          ? { kind: 'pack', packIndex: zone.packIndex, index: rowIndex }
          : { kind: 'unpacked', index: rowIndex },
    };
    event.dataTransfer.setData(
      HYPOTHESIS_CREATIVE_DRAG_MIME,
      serializeHypothesisCreativeDrag(payload),
    );
    event.dataTransfer.effectAllowed = 'move';
    attachCreativeDragPreview(event, onDragEnd);
    onDragStart?.(creativeId);
  };

  return (
    <Box
      draggable
      onDragStart={handleDragStart}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        color: 'text.disabled',
        cursor: 'grab',
        touchAction: 'none',
        '&:active': { cursor: 'grabbing' },
      }}
    >
      <DragIndicatorIcon fontSize="small" />
    </Box>
  );
};

export default CreativeDragHandle;
